import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { ConfigService as RecoveryConfigService, AppEnvironment } from '@recovery/recovery-unified-ui-common'

const name = (() => {
  const host = window.location.host
  switch (host) {
    case 'rim-prd.optum.com':
    case 'rim-ui-prd.optum.com':
    case 'rim.optum.com':
    case 'rim.prd.reco.optum.com':
      return AppEnvironment.Production;
    case 'rim-stage.optum.com':
    case 'rim-ui-stg.optum.com':
    case 'rim.stg.reco.optum.com':
      return AppEnvironment.Staging;
    case 'rim.tst.reco.optum.com':
    case 'rim-ui-tst.optum.com':
    case 'rim-test.optum.com':
      return AppEnvironment.Test;
    case 'rim.dev.reco.optum.com':
    case 'rim-ui-dev.optum.com':
    case 'rim-dev.optum.com':
      return AppEnvironment.Development;
    case 'localhost:4200':
    case 'localhost:4201':
      return AppEnvironment.Local;
    default:
      const knownOrigin = window.location.origin.match(/^https:\/\/(cashops-|rofs[.])(\w+)[.]((eph[.])?(reco[.])?optum[.]com|optum[.]com)$/i)
      if (knownOrigin) {
        const [, , environmentName] = knownOrigin
        return environmentName
      } else {
        return AppEnvironment.Local;
      }
  }
})()


 if (name === AppEnvironment.Production) {
   enableProdMode();
 }

platformBrowserDynamic([
  {
    provide: RecoveryConfigService,
    useFactory: () => new RecoveryConfigService({
      envName: name
    }),
  }
]).bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true })] })
  .catch((err) => {
    if(name === AppEnvironment.Development || name === AppEnvironment.Test){
       console.log(err);
  }
});
